export default __webpack_public_path__ + "static/media/Isha-Vaidya.c1c65f48.jpg";